export interface DoctorPatient {
  patient_id: number;
  first_name: string;
  last_name: string;
  name: string;
  gender: "male" | "female" | "other" | "prefer_not_to_say";
  dob: string | null;
  address: string;
  email: string;
  phone: string;
  created_at: string;
}

export interface CreateDoctorPatientPayload {
  first_name: string;
  last_name: string;
  gender: string;
  dob?: string | null;
  address?: string;
  phone?: string;
  email?: string;
}

export interface PaginatedPatientResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: DoctorPatient[];
}

export const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
] as const;
